import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Mixins, Spacing, ZIndex } from 'web-common/src/shared/styles';
import { NAV_HEIGHT, NAV_HEIGHT_LARGE } from '../consts';

export const Wrapper = styled.div<{ largeHeader?: boolean }>`
  display: flex;
  flex-direction: row;
  background: ${Colors.WHITE};
  border-bottom: ${Border.Base} ${Colors.GRAY_LITE_10};
  height: ${ifProp('largeHeader', NAV_HEIGHT_LARGE, NAV_HEIGHT)};
  width: 100%;
  gap: ${Spacing.SINGLE};
  padding: 0 ${Spacing.THREE_QUARTERS};
  z-index: ${ZIndex.ConsumerNavBar + 1};

  ${Mixins.Media.maxWidthSmall(`
    padding: 0 ${Spacing.HALF};
    gap: ${Spacing.HALF};
  `)}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: ${Spacing.SINGLE};
`;

export const SpacerContainer = styled.div`
  width: 100%;
`;

export const Spacer = styled.div<{ largeHeader?: boolean }>`
  height: ${ifProp('largeHeader', NAV_HEIGHT_LARGE, NAV_HEIGHT)};
  width: 100%;
`;
